import { decodeToken } from '@Services/token.service';
import { useAppSelector } from '@Utils/hooks/useStore.hook';

export const useTokenTprValueHook = (): boolean => {
  const authState = useAppSelector((state) => state.auth);
  const token = authState.accessToken || '';
  if (!token) {
    return false;
  }
  const decoded = decodeToken(token);
  const { hasTpr } = decoded;

  return hasTpr;
};

export const useTokenAccIdValueHook = (): number | undefined => {
  const authState = useAppSelector((state) => state.auth);
  const token = authState.accessToken || '';
  if (!token) {
    return;
  }
  const decoded = decodeToken(token);
  const { accountId } = decoded;

  return accountId;
};

export const useLiveConnectSuite = (): boolean => {
  const authState = useAppSelector((state) => state.auth);
  const token = authState.accessToken || '';
  if (!token) {
    return false;
  }
  const decoded = decodeToken(token);
  const { liveConnectSuite } = decoded;
  return !!liveConnectSuite;
};
